module.exports = __webpack_public_path__ + "static/media/node.fb715d72.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cardicons/node.png
// module id = 1499
// module chunks = 0